import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/delay';
import { Router } from "@angular/router"

// Added for Auth0
import { AUTH_CONFIG } from './auth0-variables';
import * as auth0 from 'auth0-js';

import * as firebase from 'firebase';
import {firebaseConfig} from '../../environments/firebase.config';

firebase.initializeApp(firebaseConfig);

@Injectable()
export class AuthService {
  isLoggedIn: boolean = false;

  // store the URL so we can redirect after logging in
  redirectUrl: string;
  userProfile: any;
  firebase_data: any;

  // login(): Observable<boolean> {
  //   return Observable.of(true).delay(1000).do(val => this.isLoggedIn = true);
  // }

  // Configure Auth0
  auth0 = new auth0.WebAuth({
      domain: AUTH_CONFIG.domain,
      clientID: AUTH_CONFIG.clientID,
      redirectUri: AUTH_CONFIG.callbackURL,
      audience: `https://${AUTH_CONFIG.domain}/userinfo`,
      responseType: 'token id_token',
      scope: 'openid user_metadata'
  });



  constructor( private router: Router) {

  }

    public getProfile(cb): void {
      const accessToken = localStorage.getItem('access_token');
      if (!accessToken) {
          throw new Error('Access token must exist to get profile');
      }

      const self = this;
      this.auth0.client.userInfo(accessToken, (err, profile) => {
          if (profile) {
              self.userProfile = profile;
          }
          cb(err, profile);
      })
    }

    public getFirebaseData(cb): void {
        const accessToken = localStorage.getItem('access_token');
        if (!accessToken) {
            throw new Error('Access token must exist to get profile');
        }

        const self = this;
        this.auth0.client.userInfo(accessToken, (err, firebase_data) => {
            if (firebase_data) {
                self.firebase_data = firebase_data;
                console.log('firebase_data = ', self.firebase_data);
            }
            cb(err, firebase_data);
        })
    }

    public login(username: string, password: string): void {
        this.auth0.client.login({
            realm: 'Username-Password-Authentication',
            username,
            password
        }, (err, authResult) => {
            if (err) {
                console.log(err);
                alert(`Error: ${err.error_description}. Check the console for further details.`);
                return;
            } else if (authResult && authResult.accessToken && authResult.idToken) {
                this.setSession(authResult);



            }
        });
    }

    public handleAuthentication(): void {
        this.auth0.parseHash((err, authResult) => {
            if (authResult && authResult.accessToken && authResult.idToken) {
                window.location.hash = '';
                this.setSession(authResult);
                this.router.navigate(['/home']);
            } else if (err) {
                this.router.navigate(['/home']);
                console.log(err);
                alert(`Error: ${err.error}. Check the console for further details.`);
            }
        });
    }

    private setSession(authResult): void {
        // Set the time that the access token will expire at
        const expiresAt = JSON.stringify(
            (authResult.expiresIn * 1000) + new Date().getTime()
        );
        localStorage.setItem('access_token', authResult.accessToken);
        localStorage.setItem('id_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);
        console.log('authResult = ', authResult);
        this.isLoggedIn = true;
        // this.router.navigate(['home']);

        // Process Firebase auth stuff
        // this.getFirebaseData(authResult.accessToken);

        // firebase.auth().signInWithCustomToken(authResult.idToken).catch(function (error) {
        //     // Handle errors here
        //     // var errorCode = error.code;
        //     var errorMessage = error.message;
        //     console.log('Firebase auth error: ', error);
        // });

        localStorage.setItem('firebase_token', authResult.idToken);
        localStorage.setItem('expires_at', expiresAt);

        const ft = authResult.idToken;
        firebase.auth().signInWithCustomToken(ft).then((user: firebase.User) => {
            console.log("JWT Login: ", user);
        }).catch(function (e) {
            console.log("JWT Error: ",e);
        });

        // this.auth0.getToken(firebaseConfig, function(err, result) {
        //     if (!err) {
        //         firebase.auth().signInWithCustomToken(authResult.accessToken).catch(function (error) {
        //             // Handle errors here
        //             // var errorCode = error.code;
        //             var errorMessage = error.message;
        //             console.log('Firebase auth error: ', error);
        //         });
        //     }
        // });


        this.router.navigate( this.redirectUrl ? [this.redirectUrl] : ['/home']);
    }

    public logout(): void {
        // Remove tokens and expiry time from localStorage
        localStorage.removeItem('access_token');
        localStorage.removeItem('id_token');
        localStorage.removeItem('expires_at');
        console.log('Logging out!');
        // Go back to the home route
        this.router.navigate(['/auth/login']);
    }

    public isAuthenticated(): boolean {
        // Check whether the current time is past the
        // access token's expiry time
        const expiresAt = JSON.parse(localStorage.getItem('expires_at'));
        return new Date().getTime() < expiresAt;
    }

  // login(username: any, password: any) {
  //   console.log('auth login');
  //   this.isLoggedIn = true;
  //   this.router.navigate( this.redirectUrl ? [this.redirectUrl] : ['/home']);
  // }

  // logout(): void {
  //   this.isLoggedIn = false;
  // }
}



// WEBPACK FOOTER //
// /Users/alex/Documents/JC/JC3 3/src/app/+auth/auth.service.ts